module.exports = __webpack_public_path__ + "static/app-shot-1-2-0129c3d1036a723cfb2ac0476e1d9aa8.jpg";